import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/date-picker/style";
import _DatePicker from "antd/lib/date-picker"; /*@客户-设备流量*/
import React from 'react';
import BossLineChart from "../../../../Common/Charts/Line/BossLineChart";
import moment from "moment";
import { connect } from "dva";
import { withRouter } from "react-router-dom";
import { parse } from "../../../../../utils/commonUtilFunc";
var RangePicker = _DatePicker.RangePicker;
var DayFlowChart = /*#__PURE__*/function (_React$Component) {
  _inherits(DayFlowChart, _React$Component);
  function DayFlowChart(props) {
    var _this;
    _classCallCheck(this, DayFlowChart);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DayFlowChart).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_dpi_days", function () {
      var payload = {
        start_tm: moment(_this.state.start_tm).format("YYYY-MM-DD HH:mm:ss"),
        end_tm: moment(_this.state.end_tm).format("YYYY-MM-DD HH:mm:ss"),
        tunnel_dir: _this.tunnel_dir_id,
        sn: _this.sn
      };
      if (_this.props.ids !== undefined) {
        payload.ids = _this.props.ids;
      }
      if (_this.props.sip) {
        payload.sip = _this.props.sip;
      }
      _this.props.dispatch({
        type: "ci0303Info/get_dpi_days",
        payload: payload
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRangePickerChange", function (dates) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        start_tm: moment(dates[0]).format("YYYY-MM-DD HH:mm:ss"),
        end_tm: moment(dates[1]).format("YYYY-MM-DD HH:mm:ss")
      }, function () {
        vm.get_dpi_days();
      });
    });
    _this.state = {
      start_tm: moment().subtract(6, 'days'),
      end_tm: moment()
    };
    var search = parse(_this.props.location.search);
    _this.sn = search.sn;
    _this.start_tm = search.start_tm;
    _this.end_tm = search.end_tm;
    _this.tunnel_dir_id = search.tunnel_dir_id;
    return _this;
  }
  _createClass(DayFlowChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_dpi_days();
    }
  }, {
    key: "render",
    value: function render() {
      var chartOption = {
        id: "dayFlow",
        containerHeight: 400,
        containerWidth: 850,
        option: {
          xAxis: {
            type: 'time',
            boundaryGap: false,
            name: "time",
            min: moment(this.state.start_tm).format("YYYY-MM-DD"),
            max: moment(this.state.end_tm).format("YYYY-MM-DD"),
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.45)"
              }
            }
          },
          grid: {
            left: '6%',
            right: '6%',
            bottom: '35%'
          },
          yAxis: [{
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(0,0,0,0.45)"
              }
            },
            name: "Daily traffic (MB)",
            axisTick: {
              show: false
            }
          }],
          series: {
            type: "line",
            name: "Daily traffic (MB)",
            data: this.props.ci0303Info.appDayFlowData,
            showSymbol: false
          }
        }
      };
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RangePicker, {
        defaultValue: [this.state.start_tm, this.state.end_tm],
        onChange: this.handleRangePickerChange
      }), /*#__PURE__*/React.createElement(BossLineChart, chartOption));
    }
  }]);
  return DayFlowChart;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0303Info = _ref.ci0303Info;
  return {
    ci0303Info: ci0303Info
  };
}
export default connect(mapDispatchToProps)(withRouter(DayFlowChart));